import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
    getAuth,
    GoogleAuthProvider,
    signInWithRedirect,
    signOut,
} from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyB0ZWfKQVYcg7DAuSANozaaO2FFrpCqBuM",
    authDomain: "reshjemgard.firebaseapp.com",
    projectId: "reshjemgard",
    storageBucket: "reshjemgard.appspot.com",
    messagingSenderId: "436004194813",
    appId: "1:436004194813:web:4e16761aeef9c129347194",
};

// Init firebase app
initializeApp(firebaseConfig);

// Init firestore service
const auth = getAuth();
const provider = new GoogleAuthProvider();

export const signInWithGoogle = () => signInWithRedirect(auth, provider);

const firestore = getFirestore();
export { auth, firestore, signOut };
